export const formatToValidDayjs = (date: string) => date.split('/').reverse().join('/');

export const capitalizeMonth = (month: string): string => month
  .charAt(0)
  .toUpperCase() + month.slice(1);
